import axios from 'axios';

// Helper to read a cookie value by name
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : undefined;
};

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add token  
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors  
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth API  
export const authAPI = {
    sendOTP: (email, registrationSource = null) => apiClient.post('/auth/send-otp', { email, registrationSource }),
    verifyOTP: (email, otp, registrationSource = null) => apiClient.post('/auth/verify-otp', { email, otp, registrationSource }),
    getCurrentUser: () => apiClient.get('/auth/me'),
    generateApiKey: () => apiClient.post('/auth/generate-api-key'),
    revokeApiKey: () => apiClient.delete('/auth/api-key'),
    getApiKeyStatus: () => apiClient.get('/auth/api-key-status'),
};

// Projects API  
export const projectsAPI = {
    getAll: (page = 1, limit = 10) => apiClient.get(`/projects?page=${page}&limit=${limit}`),
    create: (name) => apiClient.post('/projects', { name }),
    getById: (id) => apiClient.get(`/projects/${id}`),
    getEndpoints: (id, page = 1, limit = 10) =>
        apiClient.get(`/projects/${id}/endpoints?page=${page}&limit=${limit}`),
    getStats: (id) => apiClient.get(`/projects/${id}/stats`),
    update: (id, data) => apiClient.put(`/projects/${id}`, data),
    delete: (id) => apiClient.delete(`/projects/${id}`),
};

// Tests API  
export const testsAPI = {
    create: (data) => apiClient.post('/tests', data),
    getById: (id) => apiClient.get(`/tests/${id}`),
    getByEndpoint: (endpointId, page = 1, limit = 10) =>
        apiClient.get(`/tests/endpoint/${endpointId}?page=${page}&limit=${limit}`),
};

// Domains API (for paid users domain verification)
export const domainsAPI = {
    getAll: () => apiClient.get('/domains'),
    create: (domain) => apiClient.post('/domains', { domain }),
    verify: (id, method = null) => apiClient.post(`/domains/${id}/verify`, { method }),
    delete: (id) => apiClient.delete(`/domains/${id}`),
};

// Billing API (Dodo Payments checkout sessions)
export const billingAPI = {
    createCheckoutSession: (tierId) => {
        const datafastVisitorId = getCookie('datafast_visitor_id');
        return apiClient.post('/billing/create-checkout-session', {
            tierId,
            ...(datafastVisitorId && { datafastVisitorId }),
        });
    },
};

export default apiClient;

